import { timeFormatter } from '@autopass-web/domain';
import dayjs from 'dayjs';

export const sortingPromotionsByDate = (promotion) => {
  const commingSoonPromotions = promotion
    .filter((p) => new ComingSoonMatcher(p.startAt).isMatch())
    .sort((a, b) => promotionComparer(a, b));

  const NonComingSoonPromotions = promotion
    .filter((p) => !new ComingSoonMatcher(p.startAt).isMatch())
    .sort((a, b) => promotionComparer(a, b));

  return NonComingSoonPromotions.concat(commingSoonPromotions);
};

export const promotionComparer = (a, b) => {
  let currentSortDate = '';
  let compareSortDate = '';
  if (new ComingSoonMatcher(a.start).isMatch()) {
    // 即將到期的用 startAt 排序
    currentSortDate = a.startAt;
    compareSortDate = b.startAt;
  } else {
    // 非即將到期的用 endAt 排序
    currentSortDate = a.endAt;
    compareSortDate = b.endAt;
  }
  if (currentSortDate === compareSortDate) {
    return a.position - b.position;
  } else if (Date.parse(currentSortDate) > Date.parse(compareSortDate)) {
    return 1;
  } else {
    return -1;
  }
};

export class ComingSoonMatcher {
  constructor(startAt) {
    this.startAt = startAt;
  }
  isMatch = () => dayjs().isBefore(this.startAt);

  getLabel = () => `${timeFormatter(this.startAt, 'date')} 即將上線`;

  getPromotionLabel() {
    return 'ComingSoon';
  }
}

export class In24HoursMatcher {
  constructor(duration) {
    this.duration = duration;
  }

  isMatch() {
    return this.duration.asHours() < 24;
  }

  getLabel() {
    return '本日即將結束';
  }

  getPromotionLabel() {
    return 'In24Hours';
  }
}

export class Between1to7DatesMatcher {
  constructor(duration) {
    this.duration = duration;
  }

  isMatch() {
    return this.duration.asDays() > 1 && this.duration.asDays() < 7;
  }

  getLabel() {
    return `${Math.floor(this.duration.asDays())} 天後結束`;
  }

  getPromotionLabel() {
    return 'In30Days';
  }
}

export class PromotionFullMatcher {
  constructor(usagePercentage) {
    this.usagePercentage = usagePercentage;
  }

  isMatch() {
    return this.usagePercentage === 100;
  }

  getLabel() {
    return '優惠已提前結束';
  }

  getPromotionLabel() {
    return 'PromotionFull';
  }
}

export const isFromPromotionBoard = (promotion) => 'attributes' in promotion;

export const openUrl = (url) => {
  if (url === '' || url === undefined) {
    return;
  }

  window.location.href = url;
};
